module.exports = __webpack_public_path__ + "img/russia.13902542.svg";